// extracted by mini-css-extract-plugin
export default {"tab":"Tabs--tab--OrPMR","tabSelected":"Tabs--tabSelected--MQi3g"};